export const iconFontAwesomeTransportationBusSimple = (
	<i className="fa-solid fa-bus-simple"></i>
);
